export default function IosBody() {
  return (
    <div
      className="ion-icon-ios-body"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<circle cx="256" cy="79.838" r="48"/>
	<path d="M424,144H88c-13.255,0-24,10.745-24,24s10.745,24,24,24h98.451c5.579,1,13.197,3.837,17.216,14.252
		c4.651,12.056,2.37,33.606-0.539,51.727l-3.775,21.395c-0.019,0.104-0.039,0.207-0.058,0.311c-0.002,0.008-0.002,0.012-0.004,0.02
		l-30.375,172.268c-2.303,13.053,6.414,25.5,19.467,27.803c13.055,2.301,25.333-6.416,27.634-19.471L237,340.348v0.167
		c0,0,6.25-32.515,18.452-32.515h1.096C269,308,275,340.515,275,340.515v-0.083l20.983,119.913
		c2.301,13.055,14.663,21.749,27.718,19.448c13.053-2.303,21.728-14.762,19.425-27.814L312.73,279.703
		c-0.002-0.008-0.013-0.02-0.015-0.027c-0.019-0.104-0.044-0.217-0.063-0.322l-3.777-21.414
		c-2.909-18.121-5.191-39.631-0.541-51.688C312.354,195.838,319.97,193,325.549,192H424c13.255,0,24-10.745,24-24
		S437.255,144,424,144z"/>
</g>
</svg>
`,
      }}
    />
  )
}
